import Swal from "sweetalert2";
import { ip_supabase } from "./supabase";

export type AdminAccessReason = "NO_SESSION" | "ERROR" | "NOT_ADMIN";

export interface AdminAccessResult {
  ok: true;
}

export interface AdminAccessFail {
  ok: false;
  reason: AdminAccessReason;
}

export type AdminAccessCheck = AdminAccessResult | AdminAccessFail;

export async function ip_checkAdminAccess(): Promise<AdminAccessCheck> {
  const { data: s } = await ip_supabase.auth.getSession();
  const userId = s?.session?.user?.id;

  if (!userId) {
    return { ok: false, reason: "NO_SESSION" };
  }

  const { data, error } = await ip_supabase
    .from("ip_admin_users")
    .select("id")
    .eq("auth_user_id", userId)
    .maybeSingle();

  if (error) {
    await Swal.fire({
      icon: "error",
      title: "Auth error",
      text: error.message,
    });
    return { ok: false, reason: "ERROR" };
  }

  if (!data) {
    await Swal.fire({
      icon: "error",
      title: "Not authorized",
      text: "Your user is not in ip_admin_users.",
    });
    return { ok: false, reason: "NOT_ADMIN" };
  }

  return { ok: true };
}